import { getLeadTemplateSetting } from "../api/LeadTemplateSetting"
import { getAccessProductPipeline } from "../api/ProductsCRUD"
import { AccessLeadTemplate } from "../interfaces/AccessLeadTemplate"

export const getSelectedAccessLeadTemplate = async (templateId: string, token: string, setLeadTemplate: React.Dispatch<React.SetStateAction<AccessLeadTemplate | null>>) => {
  try {
    const response = await getLeadTemplateSetting(templateId, token)
    const responseProduct = await getAccessProductPipeline(templateId, token)
    if (response.data.success && responseProduct.data.success) {
      setLeadTemplate({
        ...response.data.data,
        leadProgresses: response.data.data.leadProgresses.map((progress: any) => ({
          ...progress,
          label: progress.name,
          value: progress.id,
        })),
        completeLeadProducts: response.data.data.leadProducts.map((product: any) => ({
          ...product,
          label: product.name,
          value: product.id,
        })),
        leadProducts: responseProduct.data.data.map((product: any) => ({
          ...product,
          label: product.name,
          value: product.id,
        })),
        leadSources: response.data.data.leadSources.map((source: any) => ({
          ...source,
          label: source.name,
          value: source.id,
        })),
      })
    }
  } catch (error) {
    console.log(error, 'error')
  }
}